import React, { useState } from 'react';
import classNames from 'classnames';
import Icon from '../general-components/icon';

interface Props {
	color: string; //color of icon
	icon: string; //from ICONS const
	onClick: Function;
	size: number;
	isShownOverride?: boolean | undefined;
	backgroundColor?: string; //hex color behind icon
	children?: React.ReactNode;
	left?: number; //if you want to offset the icon
	top?: number;
	style?: any;
};

export default function HoverIcon(props: Props) {
	const {
		backgroundColor = null,
		children = null,
		color,
		icon,
		isShownOverride = null,
		onClick,
		size,
		top = 20,
		left = 40,
		style = {},
	} = props;

	const [showIcon, setShowIcon] = useState<boolean>(isShownOverride === null
		? false
		: isShownOverride
	);

	const onMouseExitHandler = () => {
		if (isShownOverride === null) {
			setShowIcon(false);
		}
	};

	const onMouseEnterHandler = () => {
		if (isShownOverride === null) {
			setShowIcon(true);
		}
	};

	const iconStyleObj: React.CSSProperties = {
		paddingLeft: `${left}px`,
		paddingTop: `${top}px`,
		...(backgroundColor && { backgroundColor: backgroundColor }),
	};

	return (
		<div
			className="hover-icon"
			onMouseEnter={onMouseEnterHandler}
			onMouseLeave={onMouseExitHandler}
			style={style}
		>
			{!!children && children}
			<div
				className={classNames('hover-icon-icon', 'cursor-pointer', (!showIcon && !isShownOverride) && 'is-opaque')}
				onMouseEnter={onMouseEnterHandler}
				onClick={(e: React.MouseEvent) => onClick(e)}
				style={iconStyleObj}
			>
				<Icon name={icon} size={size} color={color} />
			</div>
		</div>
	);
}
